import { CommonModule } from '@angular/common';
import { Component, inject} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { SubjectFormComponent } from '../../../components/subject/subject-form/subject-form.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';

@Component({
  selector: 'app-subjects-index',
  standalone: true,
  imports: [
    CommonModule,
    SubjectFormComponent,
    LoaderComponent,
    TableGuruComponent
  ],
  templateUrl: './subjects-index.component.html',
  styleUrl: './subjects-index.component.scss'
})
export class SubjectsIndexComponent {
  items : []  = [];
	private modalService = inject(NgbModal);
  reloadItems: boolean = false;

  editFormReference = SubjectFormComponent;

  constructor () {}  

	openModal(item: any) {
    let self = this;
		const modalRef = this.modalService.open(SubjectFormComponent);
		modalRef.componentInstance.modalStyle = true;
		modalRef.componentInstance.item = item;
		modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
	}
}
